var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin1New(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2016 16.3566C10.6259 17.2878 12.3847 20.9667 15.2744 25.0103C15.5279 25.3636 16.0559 25.3636 16.3093 25.0103C19.199 20.9686 20.9578 17.2878 21.3821 16.3566C21.7988 15.5195 22.0369 14.5863 22.0369 13.5879C22.035 10.1395 19.2393 7.34961 15.7909 7.34961C12.3425 7.34961 9.54688 10.1395 9.54688 13.5879C9.54688 14.5863 9.78304 15.5195 10.2016 16.3566Z",
    stroke: "#0F2A59",
    strokeWidth: 0.806534,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7906 15.3917C16.9952 15.3917 17.9718 14.4151 17.9718 13.2105C17.9718 12.0058 16.9952 11.0293 15.7906 11.0293C14.5859 11.0293 13.6094 12.0058 13.6094 13.2105C13.6094 14.4151 14.5859 15.3917 15.7906 15.3917Z",
    stroke: "#0F2A59",
    strokeWidth: 0.806534,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin1New);
export default __webpack_public_path__ + "static/media/map-pin-1-new.5a2c397e93f149e8fe7288112c131244.svg";
export { ForwardRef as ReactComponent };